'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _directionalstyles = require('../utils/directionalstyles');

var _directionalstyles2 = _interopRequireDefault(_directionalstyles);

var _colors = require('../utils/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (rtl) {
    var fontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tahoma, HelveticaNeue';
    var titleFontFamily = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'tahoma, HelveticaNeue';
    var titlePaddingBottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
    var paddingBottom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
    var paddingInlineEnd = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 32;

    var _styles = {
        table: {
            width: '100%',
            maxWidth: 600
        },

        tr: {
            fontFamily: fontFamily
        },

        innerTd: {
            paddingBottom: paddingBottom,
            paddingInlineEnd: paddingInlineEnd
        },

        outerTd: {
            paddingBottom: paddingBottom,
            paddingInlineEnd: paddingInlineEnd
        },

        tdTitle: {
            fontSize: 10,
            paddingBottom: titlePaddingBottom,
            color: _colors2.default.D40,
            fontFamily: titleFontFamily,
            lineHeight: 1.2
        },

        firstCol: {
            width: '47%'
        },

        tdValue: {
            fontSize: 16,
            lineHeight: 1.5
        },

        tdComments: {
            fontSize: 16,
            fontFamily: fontFamily,
            lineHeight: 1.5
        }
    };

    return (0, _directionalstyles2.default)(_styles, rtl);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationDetails.style.js
// module id = 871
// module chunks = 0